export default __webpack_public_path__ + "static/media/gl-ex1.fa3ba466.jpg";